import { API_URL } from '../../config';
import { CALL_API } from '../../middlewares/apiMiddleware';
import { 
  SERVICES_GET_SERVICES,
  SERVICES_GET_OFFICE_INFO,
  SERVICES_SINGLE_OFFICE_INIT,
  PENDING, FULFILLED, REJECTED,
} from '../../globals';



export function getServicesRequest() {
  return {
    type: `${SERVICES_GET_SERVICES}_${PENDING}`,
  };
}

export function getServicesSuccess(response) {
  return {
    type: `${SERVICES_GET_SERVICES}_${FULFILLED}`,
    payload: {
      data: response.data,
      status: response.status,
    }
  };
}

export function getServicesFailure(response) {
  return {
    type: `${SERVICES_GET_SERVICES}_${REJECTED}`,
    payload: {
      errorMessage: response,
    }
  };
}



export function getOfficeInfoRequest() {
  return {
    type: `${SERVICES_GET_OFFICE_INFO}_${PENDING}`,
  };
}

export function getOfficeInfoSuccess(response) {
  return {
    type: `${SERVICES_GET_OFFICE_INFO}_${FULFILLED}`,
    payload: {
      data: response.data,
      status: response.status,
    }
  };
}

export function getOfficeInfoFailure(response) {
  return {
    type: `${SERVICES_GET_OFFICE_INFO}_${REJECTED}`,
    payload: {
      errorMessage: response,
    }
  };
}


export const getServices = (officeId) => ({
  [CALL_API]: {
    actions: [getServicesRequest, getServicesSuccess, getServicesFailure],
    url: `${API_URL}/web/services?store_id=${officeId}`,
  },
});


export const getOfficeInfo = (officeId) => ({
  [CALL_API]: {
    actions: [getOfficeInfoRequest, getOfficeInfoSuccess, getOfficeInfoFailure],
    url: `${API_URL}/web/stores?id=${officeId}`,
  },
});


/*
 *  Single Office Mode
 */


export const singleOfficePending = () => {
  return {
    type: `${SERVICES_SINGLE_OFFICE_INIT}_${PENDING}`,
  };
}

export const singleOfficeFulfiled = () => {
  return {
    type: `${SERVICES_SINGLE_OFFICE_INIT}_${FULFILLED}`,
  };
}

export const singleOfficeFailure = () => {
  return {
    type: `${SERVICES_SINGLE_OFFICE_INIT}_${REJECTED}`,
  };
}





